/**
 * Section Ingrédients - JavaScript
 * Flip Cards 3D + Slider Mobile + Popup + VOIR PLUS
 */

(function() {
  'use strict';

  // ================================================
  // FLIP CARDS
  // ================================================
  
  function initFlipCards() {
    // Fonction pour attacher les événements flip
    function attachFlipListeners() {
      const flipButtons = document.querySelectorAll('.ingredient-flip-btn');
      flipButtons.forEach(button => {
        button.onclick = function(e) {
          e.preventDefault();
          e.stopPropagation();
          const card = this.closest('.ingredient-card');
          if (card && !card.classList.contains('is-flipped')) {
            card.classList.add('is-flipped');
            // Attacher les listeners de retour après un court délai
            setTimeout(attachBackListeners, 100);
            // Initialiser l'indicateur de scroll
            setTimeout(initScrollIndicators, 150);
          }
        };
      });
    }

    // Fonction pour attacher les événements retour
    function attachBackListeners() {
      const backButtons = document.querySelectorAll('.ingredient-back-btn');
      backButtons.forEach(button => {
        button.onclick = function(e) {
          e.preventDefault();
          e.stopPropagation();
          const card = this.closest('.ingredient-card');
          if (card && card.classList.contains('is-flipped')) {
            card.classList.remove('is-flipped');
            // Réattacher les listeners flip après un court délai
            setTimeout(attachFlipListeners, 100);
          }
        };
      });
    }

    // Initialiser les deux types de listeners
    attachFlipListeners();
    attachBackListeners();
  }

  // ================================================
  // SCROLL INDICATORS (Gradient + Flèche)
  // ================================================
  
  function initScrollIndicators() {
    const scrollContents = document.querySelectorAll('[data-scroll-content]');
    
    scrollContents.forEach(scrollContent => {
      const cardBack = scrollContent.closest('.ingredient-card-back');
      if (!cardBack) return;
      
      function checkScrollPosition() {
        const scrollTop = scrollContent.scrollTop;
        const scrollHeight = scrollContent.scrollHeight;
        const clientHeight = scrollContent.clientHeight;
        
        // Si le contenu n'est PAS scrollable (tout est visible), afficher le bouton immédiatement
        const isNotScrollable = scrollHeight <= clientHeight + 5;
        
        // Si on est à moins de 10px du bas, on considère qu'on est en bas
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;
        
        if (isNotScrollable || isAtBottom) {
          cardBack.classList.add('scrolled-to-bottom');
        } else {
          cardBack.classList.remove('scrolled-to-bottom');
        }
      }
      
      // Écouter le scroll
      scrollContent.addEventListener('scroll', checkScrollPosition);
      
      // Vérifier au chargement
      setTimeout(checkScrollPosition, 100);
    });
  }

  // ================================================
  // SLIDER MOBILE + DOTS NAVIGATION
  // ================================================
  
  function initMobileSlider() {
    const sliderWrapper = document.querySelector('.ingredients-slider-wrapper');
    const dots = document.querySelectorAll('.slider-dot');

    if (!sliderWrapper || !dots.length) return;

    // Fonction pour mettre à jour le dot actif
    function updateActiveDot() {
      const scrollLeft = sliderWrapper.scrollLeft;
      const slideWidth = sliderWrapper.querySelector('.ingredient-slide').offsetWidth + 20; // +20 pour le gap
      const currentIndex = Math.round(scrollLeft / slideWidth);
      
      dots.forEach((dot, index) => {
        if (index === currentIndex) {
          dot.classList.add('is-active');
        } else {
          dot.classList.remove('is-active');
        }
      });
    }

    // Écouter le scroll
    sliderWrapper.addEventListener('scroll', updateActiveDot);

    // Clic sur les dots pour naviguer
    dots.forEach((dot) => {
      dot.addEventListener('click', function() {
        const index = parseInt(this.getAttribute('data-slide-index'));
        const slideWidth = sliderWrapper.querySelector('.ingredient-slide').offsetWidth + 20;
        sliderWrapper.scrollTo({
          left: slideWidth * index,
          behavior: 'smooth'
        });
      });
    });

    // Initialiser
    updateActiveDot();
  }

  // ================================================
  // POPUP
  // ================================================
  
  function initPopup() {
    const popup = document.querySelector('.ingredients-popup');
    const openBtn = document.querySelector('[data-open-popup]');
    const closeElements = document.querySelectorAll('[data-close-popup]');

    if (!popup || !openBtn) return;

    // Ouvrir popup
    openBtn.addEventListener('click', function(e) {
      e.preventDefault();
      popup.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    // Fermer popup
    closeElements.forEach(element => {
      element.addEventListener('click', function(e) {
        e.preventDefault();
        popup.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });

    // Fermer avec touche Échap
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) {
        popup.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  // ================================================
  // VOIR PLUS D'INGRÉDIENTS (Desktop uniquement)
  // ================================================
  
  function initShowMoreIngredients() {
    const toggleBtn = document.querySelector('[data-toggle-ingredients]');
    const ingredientsGrid = document.querySelector('[data-ingredients-grid]');

    if (!toggleBtn || !ingredientsGrid) return;

    toggleBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Toggle la classe "is-expanded" sur la grid
      ingredientsGrid.classList.toggle('is-expanded');
      
      // Scroll smooth vers la section si on expand
      if (ingredientsGrid.classList.contains('is-expanded')) {
        // Petit délai pour laisser l'animation se faire
        setTimeout(() => {
          const firstHiddenCard = ingredientsGrid.querySelector('.is-hidden-extra');
          if (firstHiddenCard) {
            firstHiddenCard.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'nearest' 
            });
          }
        }, 100);
      } else {
        // Si on collapse, scroll vers le haut de la grid
        ingredientsGrid.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start' 
        });
      }
    });
  }

  // ================================================
  // INITIALISATION
  // ================================================
  
  function init() {
    initFlipCards();
    initMobileSlider();
    initPopup();
    initShowMoreIngredients();
  }

  // Lancer au chargement du DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Réinitialiser si besoin (ex: après AJAX Shopify)
  document.addEventListener('shopify:section:load', init);

})();